import { Col, Row, Tabs } from 'antd'
import { useQuery } from 'modules/core/customHooks'
import { SiderLayout } from 'modules/core/layouts'
import MonitorScreen from './Monitor'
import ProcessesList from 'modules/processes/containers/ProcessesList/ProcessesList'
import { useTranslation } from 'react-i18next'
import { Navigator } from 'modules/core/components'

const MonitorsHome = () => {
  const { t } = useTranslation()
  let query = useQuery()

  const MONITOR = 'monitor'
  const PROCESSES = 'processes'

  const renderHeader = () => <Navigator floated={false} size="big" items={[{ name: 'Monitors' }]} />

  return (
    <SiderLayout>
      <Row gutter={[24, 24]}>
        <Col span={24}>{renderHeader()}</Col>
        <Col span={24}>
          <Tabs
            size="small"
            defaultActiveKey={query.get('tab') !== null ? query.get('tab') : MONITOR}
          >
            <Tabs.TabPane tab="Monitor" key={MONITOR}>
              <MonitorScreen />
            </Tabs.TabPane>
            <Tabs.TabPane tab={t('LABEL_PROCESS_UPLOAD')} key={PROCESSES}>
              <ProcessesList />
            </Tabs.TabPane>
          </Tabs>
        </Col>
      </Row>
    </SiderLayout>
  )
}

export default MonitorsHome
